import {Type} from 'class-transformer';

class O7dCpuCoreDetailDto {
  microArchitecture: string;
  maxFrequencyMhz: number;
}

export class O7dDeviceDetailDto {
  id: number;
  version: number;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;

  creatorTypeId: string;
  creatorTypeVersion?: string;

  updaterTypeId: string;
  updaterTypeVersion?: string;

  serial: string;
  manufacturerId: string;
  model: string;
  marketingName: string;

  osId: string;
  typeId: string;
  foldable: boolean;
  displayWidthPixels: number;
  displayHeightPixels: number;
  displayDensityDpi: number;
  displayCutoutPositionIds: string[];
  ramGigabytes: number | null;
  osVersion: string;
  osSdkVersion: string;
  osArchitectureId: string;
  gpu: string | null;
  gpuCoreCount: number | null;
  @Type(() => O7dCpuCoreDetailDto)
  cpuCores: O7dCpuCoreDetailDto[];
  aspectRatio: string | null;
  imei1: string | null;
  imei2: string | null;
  openglEsVersion: string | null;
  vulkanVersion: string | null;
  metalVersion: string | null;

  ownershipTypeId: string;
  assetId: string | null;
  owner: string | null;
  location: string | null;
  studioId: string | null;
  notes: string | null;

  userIds: string[];

  appleUdid: string | null;
}
